

// Direction constants
const NEXT = 1;
const PREV = -1;

// Slideshow module
class Slideshow {
	constructor(DOM_el) {
		const donateBtn = document.getElementById('donate-anchor');
		let DOM = {
			el: null,
			slides: null,
			slidesInner: null
		};
		let current = 0;
		let slidesTotal = 0;
		let isAnimating = false;

		// Initialize slideshow
		function init() {
			DOM.el = DOM_el;
			DOM.slides = [...DOM_el.querySelectorAll('.slide-gsap')];
			DOM.slidesInner = DOM.slides.map(item => item.querySelector('.slide__img'));
			slidesTotal = DOM.slides.length;
			DOM.slides[current].classList.add('slide--current');
		}

		// Navigate to next slide
		this.next = function () {
			if (!document.querySelector('.form-wrap--visible')) {
				ScrollTrigger.refresh()
				navigate(NEXT);
				return current;
			} else {
				return
			}

		};
		this.prev = function () {
			if (!document.querySelector('.form-wrap--visible') && current > 0) {
				navigate(PREV);
				return current;
			} else {
				return;

			}
		};

		// Navigate through slides
		function navigate(direction) {
			if (isAnimating) return false;
			isAnimating = true;

			const previous = current;
			current = direction === 1 ?
				current < slidesTotal - 1 ? ++current : 0 :
				current > 0 ? --current : slidesTotal - 1;

			const currentSlide = DOM.slides[previous];
			const currentInner = DOM.slidesInner[previous];
			const upcomingSlide = DOM.slides[current];
			const upcomingInner = DOM.slidesInner[current];

			gsap.timeline({
				defaults: {
					duration: 1.2,
					ease: 'power4.inOut'
				},
				onStart: () => {
					upcomingSlide.classList.add('slide--current');
				},
				onComplete: () => {
					currentSlide.classList.remove('slide--current');
					isAnimating = false;
				}
			})
				.addLabel('start', 0)
				.to(currentSlide, {
					yPercent: -direction * 100
				}, 'start')
				.to(currentInner, {
					yPercent: direction * 30,
				}, 'start')
				.fromTo(upcomingSlide, {
					yPercent: direction * 100
				}, {
					yPercent: 0
				}, 'start')
				.fromTo(upcomingInner, {
					yPercent: -direction * 30
				}, {
					yPercent: 0
				}, 'start');
		}

		init();
		donateBtn.addEventListener('click', () => {
			current = 5;
		});
	}
}

module.exports = Slideshow;
